import React, { useContext } from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { generateMetricsAttribute } from '@sm/metrics';
import { StaticContext } from '@sm/webassets/StaticContext';
import { IconArrowBox } from '@wds/icons';
import { WrappedLogo } from '~app/pages/SurveyThanks/BuildWithAI';
import TemplateCard from './components/TemplateCard';
import { ALL_SURVEY_TEMPLATES_CTA, EMPLOYEE_FEEDBACK_TEMPLATES, SURVEY_TEMPLATES } from '~app/components/constants';
import useStyles from './useStyles';

const PersonalizationEndPage = ({
  treatment,
  utSource,
  utSource2,
}: {
  treatment: string;
  utSource: string;
  utSource2: string;
}): React.ReactElement => {
  const classes = useStyles();
  const utSource3 = 'PersonalizationEndPage';
  const amplitudeEvent = 'endpageTemplateClick';

  const {
    smParams: { surveyId, collectorId, respondentId },
    templateType,
  } = useContext(StaticContext);

  const metricsProps = {
    amplitudeEvent,
    templateType,
    surveyId,
    collectorId,
    respondentId,
    utSource,
    utSource2,
    utSource3,
    interactionType: 'click',
  };

  const { heading, templateCTA, viewAllCTA, templates } = (
    treatment === 'treatment1' ? SURVEY_TEMPLATES : EMPLOYEE_FEEDBACK_TEMPLATES
  )[0];

  const ALL_TEMPLATES_URL = `${ALL_SURVEY_TEMPLATES_CTA}%3Fut_source%3Dsurvey-thanks%26ut_source2%3D${utSource2}%26ut_source3%3D${utSource3}`;

  return (
    <>
      <Box style={{ backgroundColor: '#224F3C' }}>
        <WrappedLogo utSource2="popularTemplates" />
      </Box>
      <Box pt={6} className={classes.headerSection}>
        <Typography weight="medium" align="center" component="h1">
          {heading}
        </Typography>
      </Box>
      <Box py={6} className={classes.mainSection}>
        <Box className={classes.templateCardContainer}>
          {templates.map(template => (
            <TemplateCard key={template.title} template={template} templateCTA={templateCTA} {...metricsProps} />
          ))}
        </Box>
        <Box className={classes.viewAllCTAContainer}>
          <a
            className={classes.viewAllCTA}
            href={ALL_TEMPLATES_URL}
            data-sm-metrics={generateMetricsAttribute({
              data: {
                ...metricsProps,
                itemSelected: 'view all templates',
                ctaText: viewAllCTA,
                log: { message: `${utSource}-${utSource2}-${utSource3}` },
              },
            })}
          >
            {viewAllCTA}
            <Typography component="span" color="info">
              <IconArrowBox title="Arrow Icon" />
            </Typography>
          </a>
        </Box>
      </Box>
    </>
  );
};

export default PersonalizationEndPage;
